<div class="playbooks-filters">
  <div class="playbooks-filters-row">
    <div class="left">
      <!-- Uncomment when implementing search -->
      <!-- <app-search-box class="filters-search" (textOnSelection)="searchSubmitted($event)"
                [placeholder]="'tableActionsAndFilters.searchBoxText' | labelsProvider"
                [startingValue]="pageFilters.search.getFilterValue()" [newValueTriggered$]="searchBoxNewValue">
            </app-search-box> -->
      <app-date-picker
        class="filters-date-picker"
        (dateOnSelection)="lastExecutionSinceSelected($event)"
        label="tableActionsAndFilters.lastExecutionSince"
        [startingValue]="pageFilters.lastExecutionSince.getFilterValue()"
        [maxDate]="pageFilters.lastExecutionUntil.getFilterValue()"
        [newValueTriggered$]="lastExecutionSinceNewValue"
      >
      </app-date-picker>
      <app-date-picker
        class="filters-date-picker"
        (dateOnSelection)="lastExecutionUntilSelected($event)"
        label="tableActionsAndFilters.lastExecutionUntil"
        [startingValue]="pageFilters.lastExecutionUntil.getFilterValue()"
        [newValueTriggered$]="lastExecutionUntilNewValue"
        [minDate]="pageFilters.lastExecutionSince.getFilterValue()"
      >
      </app-date-picker>
      <app-multi-select-v2
        class="filters-all"
        (optionOnSelection)="tablesFiltersChange($event)"
        [pageFilters]="pageFilters"
      >
      </app-multi-select-v2>
    </div>
    <div class="right">
      <a
        class="create-button-container"
        [routerLink]="playbookCreationAllowed() ? '/app/playbooks/new' : null"
        *ngIf="withCreateButton"
        [ngClass]="{
          'create-button-container-disabled': !playbookCreationAllowed(),
        }"
        [matTooltip]="
          !playbookCreationAllowed()
            ? playbooksCount >= maxPlaybooksCount
              ? ('playbooks.maxPlaybooksMsg' | labelsProvider)
              : ('playbooks.notAllowedToAddPlaybookMsg' | labelsProvider)
            : ''
        "
        matTooltipClass="tooltip-container"
        matTooltipPosition="below"
      >
        <img src="assets/images/common/create.svg" />
        <div>{{ 'playbooks.createPlaybook' | labelsProvider }}</div>
      </a>
    </div>
  </div>
  <app-view-filters-multi-select [pageFilters]="pageFilters"></app-view-filters-multi-select>
</div>
